import React from 'react';
import { AccountSettingRouteNames, GlobalRouteNames } from '../../../../../models/Common';
import { ReactComponent as YourPayments } from '../../../../../assets/images/accountSettings/YourPayments.svg';
import { ReactComponent as Account } from '../../../../../assets/images/accountSettings/Account.svg';
import { ReactComponent as Home } from '../../../../../assets/images/accountSettings/Home.svg';
import { ReactComponent as Notifications } from '../../../../../assets/images/accountSettings/Notifications.svg';
import { ReactComponent as Password } from '../../../../../assets/images/accountSettings/Password.svg';
import { ReactComponent as AutoPay } from '../../../../../assets/images/accountSettings/Autopay.svg';
import { ReactComponent as Devices } from '../../../../../assets/images/accountSettings/Devices.svg';

interface ControlSettings {
  label: string;
  routePath: AccountSettingRouteNames | GlobalRouteNames;
  icon: JSX.Element;
}

export const controlItemsList: ControlSettings[] = [
  {
    label: 'buttons.yourPayments',
    routePath: GlobalRouteNames.PaymentHistory,
    icon: <YourPayments />,
  },
  {
    label: 'accountSettings.account',
    routePath: AccountSettingRouteNames.AccountPage,
    icon: <Account />,
  },
  {
    label: 'accountSettings.multiAccount',
    routePath: AccountSettingRouteNames.MultiAccountPage,
    icon: <Home />,
  },
  {
    label: 'accountSettings.notifications',
    routePath: AccountSettingRouteNames.NotificationPage,
    icon: <Notifications />,
  },
  {
    label: 'accountSettings.password',
    routePath: AccountSettingRouteNames.PasswordPage,
    icon: <Password />,
  },
  {
    label: 'accountSettings.regularPayment',
    routePath: AccountSettingRouteNames.AutoReplenishmentPage,
    icon: <AutoPay />,
  },
  {
    label: 'accountSettings.devices',
    routePath: AccountSettingRouteNames.DevicesPage,
    icon: <Devices />,
  },
];
